/* Avastar product page — docs modal + custom gallery lightbox. Plain asset JS. */
(function () {
  function initDocs() {
    var modal = document.querySelector('[data-ava-pdf-modal]');
    if (!modal || modal.dataset.avaInit) return;
    modal.dataset.avaInit = '1';
    var body = modal.querySelector('[data-ava-doc-body]');
    var title = modal.querySelector('[data-ava-doc-title]');
    var openLink = modal.querySelector('[data-ava-doc-open]');

    function close() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    }
    document.querySelectorAll('[data-ava-doc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        var kind = b.getAttribute('data-kind');
        var label = b.getAttribute('data-label') || 'Supplement Facts';
        if (title) title.textContent = label;
        if (openLink) openLink.href = src;
        if (body) {
          body.innerHTML = '';
          if (kind === 'pdf') {
            var f = document.createElement('iframe');
            f.src = src; f.title = label;
            body.appendChild(f);
          } else {
            var i = document.createElement('img');
            i.src = src; i.alt = label;
            body.appendChild(i);
          }
        }
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      });
    });
    modal.querySelectorAll('[data-ava-pdf-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  }

  function initLightbox() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.avaLb) return;
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.product-media__image'));
    var srcs = [];
    imgs.forEach(function (im) {
      var s = im.currentSrc || im.src;
      if (s && srcs.indexOf(s) === -1) srcs.push(s);
    });
    if (!srcs.length) return;
    gallery.dataset.avaLb = '1';

    var dlg = document.createElement('dialog');
    dlg.className = 'ava-lightbox';
    dlg.innerHTML = '<div class="ava-lightbox__card">' +
      '<button type="button" class="ava-lightbox__close" aria-label="Close">✕</button>' +
      (srcs.length > 1 ? '<button type="button" class="ava-lightbox__nav ava-lightbox__prev" aria-label="Previous">‹</button>' : '') +
      '<img alt="Product image">' +
      (srcs.length > 1 ? '<button type="button" class="ava-lightbox__nav ava-lightbox__next" aria-label="Next">›</button>' : '') +
      '</div>';
    document.body.appendChild(dlg);
    var img = dlg.querySelector('img');
    var idx = 0;
    function show(i) {
      idx = (i + srcs.length) % srcs.length;
      img.src = srcs[idx].split('&width=')[0];
    }
    function open(i) {
      show(i);
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    }
    function close() {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }
    imgs.forEach(function (im) {
      im.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var s = im.currentSrc || im.src;
        open(Math.max(0, srcs.indexOf(s)));
      }, true);
    });
    dlg.querySelector('.ava-lightbox__close').addEventListener('click', close);
    var p = dlg.querySelector('.ava-lightbox__prev'), n = dlg.querySelector('.ava-lightbox__next');
    if (p) p.addEventListener('click', function () { show(idx - 1); });
    if (n) n.addEventListener('click', function () { show(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  /* la descripcion importada de WooCommerce trae el embed pdf-poster roto
     ("For Healthcare Professionals" + visor "Loading Viewer..."): se elimina,
     ya que ahora ese contenido vive en el toggle con los PDF reales. */
  function cleanupImportedEmbed() {
    var MARKER = /^(For Healthcare Professionals[.:]?|Loading Viewer.*|[×✕x])$/i;
    var TRIGGER = /^Supplement Facts\s*(&|and)\s*Ingredient Information/i;
    var DOCTITLE = /^(ProDigest|VitaMax|CurcuMax|Vitamin\s*D3|Omega|NAC|JointCare|Restore|Creatine|Wolverine|MuscleGuard|BPC|GI\s*Stack|ATP|Berberine)[\w\s\d+&\/().,-]*$/i;
    // restos de Avada que en WP estaban ocultos por Bootstrap (los titulos visibles vienen de .fusion-modal .modal-title)
    document.querySelectorAll('.fusion-modal, .modal.fade, .modal-backdrop, .fusion-accordian, .panel-group').forEach(function (e) { e.remove(); });
    // 1) desde cada visor roto, retirar hacia atras los encabezados del embed
    document.querySelectorAll('[class*="pdfp"]').forEach(function (wrap) {
      var prev = wrap.previousElementSibling, hops = 0;
      while (prev && hops < 8) {
        var t = (prev.textContent || '').trim();
        var isShort = t.length > 0 && t.length < 90;
        var isHeading = /^H[1-6]$/.test(prev.tagName);
        var belongs = isShort && (MARKER.test(t) || TRIGGER.test(t) || ((isHeading || prev.children.length <= 1) && DOCTITLE.test(t)));
        if (!belongs) break;
        var dead = prev; prev = prev.previousElementSibling; dead.remove(); hops++;
      }
      wrap.remove();
    });
    // 2) pasada de seguridad: marcadores sueltos (nunca toca nuestro toggle/modal ni los lightbox, cuya X es "✕")
    var nodes = Array.prototype.slice.call(document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,a,strong,em,div,span,button'));
    nodes.forEach(function (el) {
      if (!el.parentNode) return;
      if (el.closest('.ava-pro') || el.closest('[data-ava-pdf-modal]') || el.closest('.ava-lightbox')) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      if ((MARKER.test(t) || (TRIGGER.test(t) && t.length < 110)) && el.children.length <= 3) {
        el.remove();
      }
    });
  }

  /* 27-oct-2026: la etiqueta "Supplement Facts" del Product Overview se abre en un lightbox dentro de la pagina
     (antes el enlace abria la imagen en otra pestana). Cierra con la X, con Esc o con clic fuera. */
  function initFactsLightbox() {
    var links = document.querySelectorAll('.ava-ov__facts a[href]');
    if (!links.length || document.querySelector('.ava-facts-lb')) return;
    var dlg = document.createElement('dialog');
    dlg.className = 'ava-lightbox ava-facts-lb';
    dlg.setAttribute('aria-label', 'Supplement Facts');
    dlg.innerHTML = '<div class="ava-lightbox__card"><button type="button" class="ava-lightbox__close" aria-label="Close">✕</button><img alt=""></div>';
    document.body.appendChild(dlg);
    var img = dlg.querySelector('img');
    function close() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var inner = a.querySelector('img');
        img.src = a.getAttribute('href');
        img.alt = (inner && inner.getAttribute('alt')) || 'Supplement Facts';
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    dlg.querySelector('.ava-lightbox__close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  function init() { initDocs(); cleanupImportedEmbed(); initFactsLightbox(); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
